import {
  Button,
  Card,
  CardContent,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import ClipLoader from "react-spinners/ClipLoader";
import { useRef, useState } from "react";

export const Contact = () => {
  const ref = useRef(null);
  const [noMessage, setNoMessage] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [messageSent, setMessageSent] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState("");
  const [numAdults, setNumAdults] = useState("");
  const [numChildren, setNumChildren] = useState("");
  const [childrenAges, setChildrenAges] = useState("");
  const [campingUnit, setCampingUnit] = useState("");
  const [campingUnitSize, setCampingUnitSize] = useState("");
  const [numAdultsError, setNumAdultsError] = useState("");
  const [numChildrenError, setNumChildrenError] = useState("");
  const [noEmail, setNoEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [campingUnitError, setCampingUnitError] = useState(false);
  const [campingUnitSizeError, setCampingUnitSizeError] = useState(false);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const sendMessage = async () => {
    setLoading(true);

    //Check that required fields have been entered
    var errorInForm = false;

    if (subject === "Availability" && !/\S/.test(numAdults)) {
      setNumAdultsError(true);
      errorInForm = true;
    }

    if (subject === "Availability" && !/\S/.test(numChildren)) {
      setNumChildrenError(true);
      errorInForm = true;
    }

    if (subject === "Availability" && !/\S/.test(campingUnit)) {
      setCampingUnitError(true);
      errorInForm = true;
    }

    if (subject === "Availability" && !/\S/.test(campingUnitSize)) {
      setCampingUnitSizeError(true);
      errorInForm = true;
    }

    const emailRegex =
      /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
    if (!emailRegex.test(email)) {
      setNoEmail(true);
      errorInForm = true;
    }

    if (!/\S/.test(message)) {
      setNoMessage(true);
      errorInForm = true;
    }

    if (errorInForm) {
      ref.current.scrollIntoView({ behavior: "smooth" });
      setLoading(false);
      return;
    }

    let messageObject = {
      name: name,
      email: email,
      subject: subject,
      // To add: numAdults and numChildren. Probably have to be added to the back-end DTO as well
      message: message,
      numAdults: numAdults,
      numChildren: numChildren,
      childrenAges: childrenAges,
      campingUnit: campingUnit,
      campingUnitSize: campingUnitSize,
    };

    //add try catch, if successful hide form and show
    let payload;
    try {
      //https://win1083.site4now.net:8172/MsDeploy.axd?site=landsendpark-001-site1/api/Message
      //https://win1083.site4now.net:8172/MsDeploy.axd?site=landsendpark-001-site1
      //https://localhost:7297
      //still same thing... it works find when the address is https://localhost:7297/api/message, but not when
      //it's the real server address.
      const response = await fetch("https://landsendparktest.com/api/Message", {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(messageObject),
      });
      setLoading(false);
      setMessageSuccess(
        //one business day in main season
        // "Thanks, we've received your email. We'll get back to you ASAP (within one business day)."

        //7 days in offseason
        "Thank you, we've received your email. We'll get back to you within the next 48 hours (and almost always within 24 hours).",
      );
    } catch (error) {
      setMessageSuccess(
        "Sorry, there was an issue sending your email. Please try again or give us a call at (519) 596-2523.",
      );
    }

    setMessageSent(true);
  };

  return (
    <div className="page">
      {messageSuccess === "" ? (
        <>
          <Typography gutterBottom sx={{ backgroundColor: "#ffee90", p: 2 }}>
            <strong>
              If asking about specific availability, it is necessary for us to
              have the following information: your camping unit (e.g. tent,
              trailer), its length in feet (when fully open, if applicable to
              trailers), and the number of adults and children who will be
              camping.
            </strong>
          </Typography>

          {/* <div align="center"> */}
          <div align="center">
            <div className="email-and-phone-divs" align="center">
              <PhoneIcon />
              <Typography>
                <strong>Phone</strong>
              </Typography>
              <Typography>(519) 596-2523</Typography>
            </div>
            <div className="email-and-phone-divs" align="center">
              <PhoneIcon />
              <Typography>
                <strong>Email</strong>
              </Typography>
              <Typography>mail@landsendpark.com</Typography>
            </div>
          </div>
          {/* </div> */}
        </>
      ) : null}

      {messageSent ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Typography>{messageSuccess}</Typography>
        </div>
      ) : (
        <div className="emailForm">
          <Card style={{ border: "none", boxShadow: "none" }}>
            <CardContent>
              <Grid container spacing={2.5}>
                {/* Three fields for getting their contact info */}
                <Grid item xs={12}>
                  <Typography>
                    <strong>
                      Fill this out to send us an email and we'll be happy to
                      get back to you!
                    </strong>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    value={name}
                    onChange={handleNameChange}
                    label="Name"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value);
                      setNoEmail(false);
                    }}
                    label="Your Email Address"
                    variant="outlined"
                    fullWidth
                    error={noEmail}
                    helperText={
                      noEmail ? "Please enter a valid email address" : ""
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    ref={ref}
                    select
                    value={subject}
                    onChange={handleSubjectChange}
                    label="Email Subject"
                    fullWidth
                  >
                    <MenuItem value="Availability">Availability</MenuItem>
                    <MenuItem value="Cancellation">Cancellation</MenuItem>
                    <MenuItem value="Changes">
                      Changes To An Existing Reservation
                    </MenuItem>
                    <MenuItem value="General Question">
                      General Question / Inquiry / Anything Else
                    </MenuItem>
                  </TextField>
                </Grid>

                {subject === "Availability" ? (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={numAdults}
                      onChange={(event) => {
                        setNumAdults(event.target.value);
                        setNumAdultsError(false);
                      }}
                      label="Number of Adults"
                      variant="outlined"
                      fullWidth
                      error={numAdultsError}
                      helperText={numAdultsError ? "Required" : ""}
                    />
                  </Grid>
                ) : null}

                {subject === "Availability" ? (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={numChildren}
                      onChange={(event) => {
                        setNumChildren(event.target.value);
                        setNumChildrenError(false);
                      }}
                      label="Number of Children"
                      variant="outlined"
                      fullWidth
                      error={numChildrenError}
                      helperText={numChildrenError ? "Required" : ""}
                    />
                  </Grid>
                ) : null}

                {subject === "Availability" ? (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={childrenAges}
                      onChange={(event) => {
                        setChildrenAges(event.target.value);
                      }}
                      label="Children Ages"
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                ) : null}

                {subject === "Availability" ? (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={campingUnit}
                      onChange={(event) => {
                        setCampingUnit(event.target.value);
                        setCampingUnitError(false);
                      }}
                      label="Type of camping unit (e.g. tent, cabin, trailer, motorhome with slide)"
                      variant="outlined"
                      fullWidth
                      error={campingUnitError}
                      helperText={campingUnitError ? "Required" : ""}
                    />
                  </Grid>
                ) : null}

                {subject === "Availability" ? (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={campingUnitSize}
                      onChange={(event) => {
                        setCampingUnitSize(event.target.value);
                        setCampingUnitSizeError(false);
                      }}
                      label="Camping Unit Length in Feet (when fully open if applicable for trailers)"
                      variant="outlined"
                      fullWidth
                      error={campingUnitSizeError}
                      helperText={campingUnitSizeError ? "Required" : ""}
                    />
                  </Grid>
                ) : null}
                {/* The text area for entering their message */}
                <Grid item xs={12}>
                  <TextField
                    value={message}
                    onChange={(event) => {
                      setMessage(event.target.value);
                      setNoMessage(false);
                    }}
                    multiline
                    rows={12}
                    label="Message"
                    variant="outlined"
                    fullWidth
                    error={noMessage}
                    helperText={noMessage ? "Please enter a message" : ""}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    onClick={sendMessage}
                    type="submit"
                    variant="contained"
                  >
                    Send
                  </Button>
                  <ClipLoader loading={loading} size={14}></ClipLoader>
                  {noEmail ||
                  numAdultsError ||
                  numChildrenError ||
                  noMessage ? (
                    <Typography>Please check for required fields</Typography>
                  ) : null}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
      )}

      <Grid item xs={0} sm={4}></Grid>
    </div>
  );
};
